import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function OndemandVideoIcon(props: IconProps) {
    return <Icon {...props} iconKey={"ondemand_video"}/>
}
